export default {
  pending: {
    topRow: {
      backgroundColor: 'secondaryAccent.light',
      p: '1.35rem 1.15rem',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      rowGap: '.6rem'
    },
    bottomRow: {
      display: 'flex',
      rowGap: '1rem',
      whiteSpace: 'nowrap',
      columnGap: '2rem',
      width: '100%',
      backgroundColor: 'bg.main',
      border: '1px solid',
      borderColor: 'border.lighter',
      justifyContent: 'flex-end',
      p: '.8rem 1rem'
    }
  }
};
